import lyReadMore from 'read-more';

import './vendor/owl.carousel.js' //quiet
import './vendor/lightbox.js' //quiet

(function ($, lyReadMore) {
  var reviewsSectionElem = $('.about-us__reviews__container'),
    reviewsSectionContentElem = $('[data-name="reviews-all"]'),
    summaryElem = $('[data-name="reviews-section-summary"]'),
    reviewsData,
    hasReviewsHash,
    reviewsClone,
    aboutClone,
    titleClone,
    indexSelect,
    contactClone;

  window.lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true,
    'alwaysShowNavOnTouchDevices': true,
  });

  function updateTabLayout(data) {

    var regex = /#reviews$/gi,
      $tabs;

    aboutClone = $('[data-name="aboutUs"]').clone().addClass('clone')[0].outerHTML;
    contactClone = $('[data-name="contact"]').clone().addClass('clone')[0].outerHTML;
    reviewsClone = data.hasReviews && $('[data-name="reviews"]').clone().addClass('clone').removeClass('hide')[0].outerHTML;
    titleClone = $('.location-card__title-container').clone().addClass('clone')[0].outerHTML;

    // Append clones to about tab and contact tab
    $('#aboutTab').append(aboutClone);
    $('#contactTab').append(contactClone);

    // Only append clone html if reviews exist
    if (data.hasReviews) {
      $('#reviewsTab').append(reviewsClone);
    }

    // Move the title container to right below the map
    $('#mobileMap').after(titleClone);

    // After clone, reveal link needs to be assigned reveal open method
    // If you don't it won't open the modal because foundation has already been initialized
    // Even after placing the foundation init after all scripts have loaded, this is still an issue
    $('#aboutTab .free-modal-link-js').click(function () {

      $('#free-delivery-disclaimer').foundation('reveal', 'open');

    });

    // Open reviews tab
    hasReviewsHash = regex.test(window.location.href);

    indexSelect = data.hasReviews && hasReviewsHash && window.innerWidth <= 720 ? 1 : 0;

    // Initialize tabs
    $tabs = $('#tabs').tabs({
      activate: function (event, ui) {

        var newPanelId = $(ui.newPanel).attr('id');

        // Scroll to top
        $('html').animate({
          scrollTop: 0
        }, 400);

        // Set sliding line class to current panel
        $('#slidingLine').attr('class', 'sliding-line');

        $('#slidingLine').addClass(newPanelId);

      }
    });

    $('#slidingLine').addClass(indexSelect === 1 ? 'reviewsTab' : 'aboutTab');

    $tabs.tabs('option', 'active', indexSelect);

    // Disable reviews tab if no reviews
    if (!data.hasReviews) {

      $('#tabs').addClass('js__reviews-removed');
      $tabs.tabs('option', 'disabled', [1]);

    }

    initCarousels();

  }

  function init() {

    if (!reviewsSectionElem || !reviewsSectionElem[0]) {

      return;

    }

    $.get('/reviews/about_us', onFetchReviews);

  }

  function lovinglyReviewsShowable(summary, reviews) {

    return summary &&
      reviews &&
      summary.average_rating >= 3;

  }

  function onFetchReviews(res) {

    reviewsData = res;

    if (!lovinglyReviewsShowable(reviewsData.summary, reviewsData.reviews)) {

      updateTabLayout({
        hasReviews: false
      });

      return;

    }

    summaryElem.html(reviewsData.summary_html);
    reviewsSectionContentElem.append(reviewsData.reviews_html);

    // Find all reviews stars and initialize them
    if (reviewsSectionContentElem.find('.reviews-section-rating-container')){
      reviewsSectionContentElem.find('.reviews-section-rating-container')
        .rateYo();
    }

    updateTabLayout({
      hasReviews: true
    });

    // console.log('about us read more', lyReadMore);
    lyReadMore('.reviews-carousel-review-content', {
      moreLinkText: '…Read More'
    });

    reviewsSectionElem.show();

    window.lazyLoader.revalidate();
    if (window.location.hash === '#reviews') {
      window.location.replace(window.location.hash);
    }
    
  }

  $(window).load(function () {
    init();
  });

  function initCarousels() {
    $('.owl-awards').owlCarousel({
      navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>`
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 3,
          dots: true,
        },
        720: {
          items: 4,
          nav: true,
          dots: false
        },
        1000: {
          items: 5,
          nav: true,
          dots: false,
        }
      }
    });

    $('.owl-gallery').owlCarousel({
      navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>`
      ],
      nav: true,
      center: true,
      loop: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          dots: false,
        },
      }
    });
  }

})(jQuery, lyReadMore);